// Generic Function
export const onCompletedAction = (
  mutationType,
  setOpenSnackBar,
  setSnackBarMsg,
  history,
  urlBackPath
) => {
  if (mutationType === 'make') {
    setOpenSnackBar(true)
    setSnackBarMsg(`Successfully allocated`)
    history.push(urlBackPath.substring(0, urlBackPath.lastIndexOf('/')))
  }
}
